import React from 'react'
import styles from './threePsCodes.module.css';
import { ThreePsCodeHeader } from './components/threePsCodeHeader/threePsCodeHeader.index';
import { ThreePsCodeTable } from './components/threePsCodeTable/threePsCodeTable.index';
import { useThreePsCodesPage } from './threePsCodes.hooks';
import { TablePagination } from '@mui/material';
import { rowCountPerPageOptions } from '../../constants/rowsPerPageOptions';
import { useThreePsCodesStore } from './store/threePsCodes.store';
import { selectPageSize, selectPageIndex, selectTotalThreePsCodes } from './store/threePsSelectors';

export const ThreePsCodes = () => {
    const {
        editableCodes,
        attemptedSave,
        confirmChange,
        handleCancel,
        handleFieldChange,
        handleSave,
        handleChangePage,
        handleChangePageSize,
    } = useThreePsCodesPage();

    const pageSize = useThreePsCodesStore(selectPageSize);
    const pageIndex = useThreePsCodesStore(selectPageIndex);
    const totalThreePsCodes = useThreePsCodesStore(selectTotalThreePsCodes);

    return (
        <div className={styles.threePsCodesContainer}>
            <ThreePsCodeHeader
                onSave={handleSave}
                onCancel={handleCancel}
                confirmChange={confirmChange}
            />
            <div className={styles.tableCtn}>
                <ThreePsCodeTable
                    data={editableCodes}
                    onFieldChange={handleFieldChange}
                    attemptedSave={attemptedSave}
                />
                <div className={styles.tablePaginationCtn}>
                    <TablePagination
                        count={totalThreePsCodes}
                        page={pageIndex - 1}
                        rowsPerPage={pageSize}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangePageSize}
                        rowsPerPageOptions={rowCountPerPageOptions}
                        component="div"
                    />
                </div>
            </div>
        </div>
    );
}
